<ng-container *ngIf="story$ | async as story; else loadingOrError">
  <main>
    <section class="crumbs">
      <a [routerLink]="nav_path.stories">Stories</a>
      <mat-icon>chevron_right</mat-icon>
      <a>{{story.type | capitalizeFirstLetter}}s</a>
    </section>

    <div class="story-header">
      <h1 class="story-title">
        <anon-story-title [type]="story.type" [status]="story.problemStatus">{{story.title}}</anon-story-title>
      </h1>

      <div class="details">
        <div class="author-details">
          <div class="image">
            <ng-container *ngIf="story.author?.image; else noPhoto">
              <img class="user-photo" [src]="story.author?.image" [alt]="story.author?.name+' profile photo'" />
            </ng-container>
            <ng-template #noPhoto>
              <mat-icon class="material-icons-round user-icon">account_circle</mat-icon>
            </ng-template>
          </div>
          <div class="name">{{story.author?.name}}</div>
        </div>
        <div class="story-details">
          <div class="date">{{story.created.seconds * 1000 | date}}</div>
          <div class="read-time">{{story.readTime}} min read</div>
        </div>
      </div>

      <ng-container *ngIf="story.tags?.length">
        <mat-chip-set class="tags" role="list">
          <em>Tags</em>
          <mat-chip *ngFor="let tagSlug of story.tags" role="listitem">{{tagSlug}}</mat-chip>
        </mat-chip-set>
      </ng-container>
    </div>

    <section class="story">
      <article class="ck-content" [innerHTML]="((story.content | removeStoryTitle) ?? '') | safe:'html'"></article>
    </section>

    <hr class="divider" />

    <section class="comments">
      <ng-container *ngIf="story.allowComments && story.status === 'published'; else commentsOff">
        <ng-container *ngIf="storyComments$ | async as comments; else loadingOrErrorComments">
          <div class="header">
            <div class="count">{{comments.length}} {{comments.length === 1 ? 'Comment' : 'Comments'}}</div>
            <div class="add-comment">
              <div class="top">
                <div class="image-container">
                  <ng-container *ngIf="auth.user?.photoURL; else noUserPhoto">
                    <picture *ngIf="auth.user?.photoURL">
                      <img [src]="auth.user?.photoURL" [alt]="auth.user?.displayName" />
                    </picture>
                  </ng-container>
                  <ng-template #noUserPhoto>
                    <div class="noUserPhoto"> {{auth.user?.displayName?.charAt(0)}} </div>
                  </ng-template>
                </div>
                <form [formGroup]="addCommentForm">
                  <mat-form-field>
                    <mat-label>Add a comment...</mat-label>
                    <textarea #commentInput matInput formControlName="content" rows="1" (focus)="typeComment()"></textarea>
                  </mat-form-field>
                </form>
              </div>
              <div class="bottom" *ngIf="commentSectionActive">
                <button mat-button (click)="cancelComment()">Cancel</button>
                <button mat-raised-button color="primary" [disabled]="addCommentForm.invalid" (click)="addComment()">Comment</button>
              </div>
            </div>
          </div>
          <div class="comment-list">
            <div class="comment" *ngFor="let comment of comments">
              <div class="image-container">
                <ng-container *ngIf="comment.author?.image; else noCommentPhoto">
                  <picture *ngIf="comment.author?.image">
                    <img [src]="comment.author?.image" [alt]="comment.author?.name" />
                  </picture>
                </ng-container>
                <ng-template #noCommentPhoto>
                  <div class="noCommentPhoto"> {{comment.author?.name?.charAt(0)}} </div>
                </ng-template>
              </div>
              <div class="comment-details">
                <div class="author">{{comment.author?.name}} <em>{{comment?.created?.seconds! * 1000 | dateAgo}}</em></div>
                <div class="content">{{comment.content}}</div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #loadingOrErrorComments>
          <anon-loading-or-error [error]="storyCommentsError"></anon-loading-or-error>
        </ng-template>
      </ng-container>

      <ng-template #commentsOff>
        <div class="comments-off">
          <span>Comments are turned off.</span>
          <a mat-button color="primary" [routerLink]="[nav_path.answersComments]" target="_blank">Learn more</a>
        </div>
      </ng-template>
    </section>

  </main>
</ng-container>

<ng-template #loadingOrError>
  <anon-loading-or-error [error]="error"></anon-loading-or-error>
</ng-template>
